import http from "../utils/request";

// 获取运营标识列表
export function getTagList(params) {
  return http.get("/tagMusic/getCommonTag", { params });
}

// 添加运营标识
export function addTag(params) {
  return http.post("/tag/add", params);
}

// 更新运营标识
export function updateTag(params) {
  return http.post("/tag/update", params);
}

// 删除运营标识
export function deleteTag(id) {
  return http.post("/tag/delete", {
    id: id,
  });
}
